import { useNavigate } from 'react-router';
import { useAiChatPanel } from '@/hooks/aiChat/useAiChatPanel';

interface ChatLinkProps {
    href: string;
    children: React.ReactNode;
}

export const ChatLink = ({ href, children }: ChatLinkProps) => {
    const navigate = useNavigate();
    const { close } = useAiChatPanel();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        navigate(href);
        close();
    };

    return (
        <a
            href={href}
            onClick={handleClick}
            className="text-primary dark:text-accent underline"
        >
            {children}
        </a>
    );
};
